<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: AssetListing.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <tr class="asset-list">
    <td class="first-column">
      <div
        title="Select asset"
        id="select-checkbox"
        class="asset-list__select-checkbox custom-control custom-checkbox"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          :id="selectId"
          :checked="value"
          @input="emitSelection"
        />
        <label role="button" class="custom-control-label" :for="selectId"></label>
      </div>
      <div class="d-inline-block">
        <!-- <button
          v-if="auth && isUser"
          class="asset-list__lab asset-button btn btn-reset btn-sm text-main"
          @click.prevent="emitAssetLabModal()"
          :disabled="noLab"
        >
          <i class="icon icon-lab text-main"></i>
        </button> -->
        <!-- <button
          type="button"
          v-if="auth && isUser"
          class="asset-list__lab asset-button btn btn-reset btn-sm text-main"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="icon icon-lab text-main bold-me"></i>
        </button>
        <div class="dropdown-menu">
          <a
            class="asset-list__Jupyter-lab asset-button dropdown-item"
            href="#"
            v-for="lab in data.asset_labs"
            :key="lab.name"
            @click.prevent="emitAssetLabModal(lab.name)"
            >{{ lab.name }}</a
          >
        </div>-->
      </div>
      <!-- <button
        type="button"
        class="asset-list__download asset-button btn btn-reset btn-sm"
        @click.prevent="download"
        :class="clsOngoingDownload"
        :disabled="ongoingDownload"
      >
        <i class="icon icon-download font-18 text-main bold-me"></i>
      </button> -->
      <button
        title="More"
        type="button"
        class="asset-list__view asset-button btn btn-reset btn-sm"
        @click.prevent="emitOpenModal"
      >
        <i class="icon icon-dots-three-horizontal text-main font-18"></i>
      </button>
      <!-- <div v-if="data.resource_type">
        <div v-if="data.resource_type.picture && data.resource_type.picture != 'None'">
          <img width="25" height="25" :src="data.resource_type.picture" alt="" />
        </div>
      </div> -->
    </td>

    <!-- <td v-for="(col, idx) in displayedColumns" :key="idx">{{ rowObj[columnsMapping[col]] }}</td> -->
    <td v-for="(col, idx) in displayedColumns" :key="idx">{{ getData(columnsMapping[col]) }}</td>
    <!-- <td>{{ filename }}</td> -->
    <!-- <td v-show="'File Path' in columnKeys">{{ path }}</td>
    <td v-show="'Description' in columnKeys">{{ desc }}</td>-->
    <!-- <td v-show="'Class' in columnKeys">{{ class_aux }}</td> -->
    <!-- <td v-show="'Organisation' in columnKeys">
      <p v-for="val in organisations" :key="val">{{ val }}</p>
    </td>-->
    <!-- <td v-show="'Domains' in columnKeys">
      <p v-for="val in domains" :key="val">{{ val }}</p>
    </td>-->
    <!-- <td v-show="'Ob. Constellations' in columnKeys">
      {{ constellations }}
    </td>
    <td v-show="'Ob. Satellites' in columnKeys">{{ satellites }}</td>
    <td v-show="'Observables' in columnKeys">{{ observables }}</td>
    <td v-show="'Asset Type' in columnKeys">{{ asset_type }}</td>
    <td v-show="'Collection' in columnKeys">{{ name }}</td>
    <td v-show="'Date' in columnKeys">{{ date }}</td>-->
  </tr>
</template>

<script>
import createComponent from '@/models/asset_component'

const component = createComponent()
component.props['displayedColumns'] = Array
component.props['columnsMapping'] = Object
// component.computed['columnKeys'] = function() {
//   const keys = {}
//   for (const col of this.displayedColumns) {
//     keys[col] = true
//   }

//   return keys
// }
// included better in asset_component
// component.computed['rowObj'] = function() {
//   return {
//     filename: this.filename,
//     path: this.path,
//     'file_format.description': this.desc,
//     'collection.network_organisation.name': this.organisations.join(', '),
//     'cons_dict.cons_name': this.constellations,
//     'sat_dict.sat_name': this.satellites,
//     'obs_dict.obs_name': this.observables,
//     'resource_type.name': this.resource_type,
//     'collection.name': this.name,
//     ingestion_time: this.date,
//   }
// }

component.mounted = function() {
  // console.log('MYCOLS', this.columnsMapping)
}
export default component
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~@/styles/globals';

.first-column {
  display: flex;
}

#select-checkbox {
  padding-left: 18px !important;
  padding-right: 6px;
}

.custom-checkbox .custom-control-input:checked:focus ~ .custom-control-label::before {
  box-shadow: none;
  border-color: $main;
}

.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
  border-color: $main;
}

.custom-checkbox .custom-control-input:active ~ .custom-control-label::before {
  background-color: $main;
  border-color: $main;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: $main;
  border-color: $main;
}

input:focus,
input:active {
  outline: 0;
}

.asset-button {
  padding: 0.3rem 0 0 0;
}

.custom-control-label {
  &::before {
    width: 21px;
    height: 21px;
    border: 2px solid $main;
  }

  &::after {
    width: 20px;
    height: 20px;
    color: $main;
  }
}
</style>
